import React from 'react';

export const ICPFooter: React.FC = () => {
  return (
    <footer className="fixed bottom-0 left-0 z-40 w-full border-t border-gray-200 bg-white/90 py-1 text-center text-xs text-gray-600 backdrop-blur-sm">
      <p>
        <a
          href="https://beian.miit.gov.cn/"
          target="_blank"
          rel="noreferrer"
          className="hover:text-indigo-700"
        >
          浙ICP备2026010331号-1
        </a>
      </p>
    </footer>
  );
};

